export default {

    dynamicText: {
        lines_DYNAMIC: {
            styleName: "desktopLabels"
        },
        coinValue_DYNAMIC: {
            styleName: "desktopLabels"
        },
        mobileCoinValue_DYNAMIC: {
            styleName: "desktopLabels"
        },
        bet0_DYNAMIC: {
            styleName: "desktopLabels"
        },
        bet1_DYNAMIC: {
            styleName: "desktopLabels"
        },
        bet2_DYNAMIC: {
            styleName: "desktopLabels"
        },
        bet3_DYNAMIC: {
            styleName: "desktopLabels"
        },
        bet4_DYNAMIC: {
            styleName: "desktopLabels"
        },
        win_DYNAMIC: {
            styleName: "desktopLabels"
        },
        freespinsLeft_DYNAMIC: {
            styleName: "desktopLabels"
        },
        fsTotalWin_DYNAMIC: {
            styleName: "desktopLabels"
        },
        mobileWin_DYNAMIC: {
            styleName: "mobileDynamic"
        },
        mobileFS_DYNAMIC: {
            styleName: "desktopLabelsFS"
        },
        fS_DYNAMIC: {
            styleName: "desktopLabels"
        },
        balance_DYNAMIC: {
            styleName: "leftDynamic"
        },
        betCellText_DYNAMIC: {
            styleName: "betCell"
        },
        mobileBalance_DYNAMIC: {
            styleName: "mobileDynamic"
        },
        mobileBet_DYNAMIC: {
            styleName: "mobileBetDynamic"
        },
        winScoreFly_DYNAMIC: {
            styleName: "scoreFlyDynamic"
        },
        autoplayCounter_DYNAMIC: {
            styleName: "systemCenter35"
        },
        singleWin_DYNAMIC: {
            styleName: "systemCenter15"
        },
        singleWinPortrait_DYNAMIC: {
            styleName: "systemCenter35Grey"
        },
        cashIncrease_DYNAMIC: {
            styleName: "systemCenter15"
        },
        cashIncreasePortrait_DYNAMIC: {
            styleName: "systemCenter35Grey"
        },
        mobileAutoplayCounter_DYNAMIC: {
            styleName: "mobileAutoplayCounter"
        },
        cashDecrease_DYNAMIC: {
            styleName: "systemCenter15"
        },
        cashDecreasePortrait_DYNAMIC: {
            styleName: "systemCenter35Grey"
        },
        autospinsValuePortrait_DYNAMIC: {
            styleName: "systemCenter70"
        },
        betSettingValue_DYNAMIC: {
            styleName: "systemCenter70"
        },
        betValuePortrait_DYNAMIC: {
            styleName: "desktopLabels"
        },
        betValueDesktop_DYNAMIC: {
            styleName: "betValueDesktop"
        },
        Watches: {
            styleName: "watch"
        },
        paytableValue: {
            styleName: "infoSmallText"
        },
        rtp_DYNAMIC: {
            styleName: "rtp"
        }
    }
}